import styled from "styled-components";
import { Link as LinkR } from 'react-router-dom';

export const HeroMain = styled.div`
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.8)), url('/images/slider_4.png') center/cover no-repeat;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 10rem 5% 5rem;
    color: #fff;
    text-align: center;
`;

export const HeroContent = styled.div`
    max-width: 1200px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4rem;
`;

export const MainTitle = styled.h1`
    font-size: 6rem;
    font-weight: 700;
    letter-spacing: 2px;
    margin-bottom: 2rem;
    color: #ffffff;
    text-transform: uppercase;
    
    @media (max-width: 768px) {
        font-size: 4rem;
    }
`;

export const WelcomeNote = styled.div`
    max-width: 800px;
    h2 {
        font-size: 2.5rem;
        font-weight: 600;
        margin-bottom: 1.5rem;
        color: #fca311;
    }
    p {
        font-size: 1.6rem;
        line-height: 1.8;
        font-weight: 300;
        color: #e5e5e5;
    }
    
    @media (max-width: 768px) {
        h2 { font-size: 2rem; }
        p { font-size: 1.4rem; }
    }
`;

export const WhyUsContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 2rem;
    width: 100%;
    margin-top: 2rem;
`;

export const WhyUsCard = styled.div`
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
    padding: 2.5rem;
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    text-align: left;
    transition: transform 0.3s ease;
    
    &:hover {
        transform: translateY(-5px);
        background: rgba(255, 255, 255, 0.15);
    }

    h4 {
        color: #fca311;
        font-size: 1.8rem;
        margin-bottom: 1rem;
        font-weight: 600;
    }

    p {
        font-size: 1.4rem;
        line-height: 1.6;
        color: #ddd;
    }
`;

export const CallToAction = styled.div`
    margin-top: 3rem;
    h3 {
        font-size: 2.2rem;
        font-weight: 500;
        margin-bottom: 2rem;
    }
`;

export const ContactButton = styled(LinkR)`
    background: #fca311;
    color: #000;
    padding: 1.2rem 3rem;
    font-size: 1.6rem;
    font-weight: 600;
    border-radius: 5px;
    text-transform: uppercase;
    letter-spacing: 1px;
    transition: all 0.3s ease;

    &:hover {
        background: #e59400;
        color: #000;
        transform: scale(1.05);
    }
`;